import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-container">
        <div className="footer-text">
          <span>&copy; {new Date().getFullYear()} SheetPilot. Powered by Mindlink Tec Ltd</span>
        </div>
        <div className="footer-links">
          <Link to="/terms" className="footer-link">Terms of Service</Link>
          <Link to="/privacy" className="footer-link">Privacy Policy</Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
